// extracted by mini-css-extract-plugin
export default {"charts":"performancePreview_charts__id9rA","chart":"performancePreview_chart__1mScF","heading":"performancePreview_heading__gqTgV"};